import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      {/* Quick Links Column */}
      <div className="footer-column">
        <h3 className="footer-heading">Quick Links</h3>
        <ul className="quick-links">
          <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
          <li><Link to="/AboutUs" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
          <li><Link to="/Products" onClick={() => window.scrollTo(0, 0)}>Products</Link></li>
          <li><Link to="/ContactUs" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
        </ul>
      </div>

      {/* Address Column 1 */}
      <div className="footer-column">
        <h3 className="footer-heading">Factory</h3>
        <div className="address-section">
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
            </span>
            <p className="address-text">
              ½ Km Raiwind Road, Raiwind
              Lahore-Pakistan            </p>
          </div>
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                />
              </svg>
            </span>
            <p className="address-text">+92-42-35392174

            </p>
          </div>
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                />
              </svg>
            </span>
            <p className="address-text">info@karimindustries.com.pk

            </p>
          </div>
        </div>
      </div>

      {/* Address Column 2 */}
      <div className="footer-column">
        <h3 className="footer-heading">Head Office</h3>
        <div className="address-section">
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
            </span>
            <p className="address-text">
              135-C Nawab Town, Thokar Niaz Baig
              Lahore-Pakistan           </p>
          </div>
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                />
              </svg>
            </span>
            <p className="address-text">+92-42-35233001</p>
          </div>
          <div className="address-item">
            <span className="address-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                />
              </svg>
            </span>
            <p className="address-text">karim.industries786@gmail.com

            </p>
          </div>
        </div>
      </div>

      {/* Social Media Column */}
      <div className="footer-column">
        <h3 className="footer-heading">Connect with Us</h3>
        <div className="social-media">
          {/* Facebook */}
          <a
            href="https://www.facebook.com/photo/?fbid=454522203357511&set=a.454522190024179"
            className="social-icon"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
              />
            </svg>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/karimindustries?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            className="social-icon"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
              />
            </svg>
          </a>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          &copy; 2026 Karim Industries. All rights reserved |
          Designed and Developed by <strong>Muhammad Atif Qureshi</strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
